import { defineStore } from 'pinia';

export const useUserStore = defineStore('user', {
  state: () => {
    return {
        publicKey:'BOWPTb9St2SsOakxuSEvA5bmYKFcSQM7v_K_E_xglQsPAretHu28vsoz1A7ZNLXnxWafo05E4VEtgNxdeVn8Y2s',
        iddisp:'',
        correo:'',
        idp:'',
        anioIngreso:'',
        correoVerificado:0,
        datosRegistrados:0,
        datosValidados:0,
        documentosCargados:0,
        documentosValidados:0,
        fichaRegistroRegistrada:0,
        fichaRegistroCargada:0,
        fichaRegistroValidada:0,
        descargaComprobanteInscripcion:0,
        numeroControl:'',
        sistema:'',
        carrera:'',
        horario:'',
        registroView:false,
        userName:'userName desde pinia',
        nombre:'',
        ap1:'',
        ap2:'',
        status:'',
        datosStatus:0,        
        documentosStatus:0,
        fichaRegistro:0,
        comprobanteInscripcionDescargado:0,
        registroCompleto:0,
        userID:'',        
        plantel:'',
        login:0,        
        showLogin:0,
        showRegistro:0,
        
    }
  },
  // could also be defined as
  // state: () => ({ count: 0 })
  actions: {
    getUsername() {
      return this.userName;
    },
    setUsername(newUserName) {
        this.userName=newUserName;
    },
    
  },
});